<template>
<div class="chapter">
<div class="inner_page">
<p class="chaptitle"><b>CONTENTS</b></p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">The Ghost of the Grand Theatre</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">The Legend of the Melon Heads</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">The Shoe Tree Legend</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">Haunted Lake Forest Cemetery</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">Haunted Nunica Cemetery</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">The Ghosts of Bower’s Harbor Inn</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">The Ghost Lovers of Castle Park</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">Grand Traverse Lighthouse</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample">The Legend of Dogman</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">The Old Traverse City State Hospital</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">The Ghost of Charles Hackley</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">The Felt Mansion</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">The Lost Souls of the <i>Alpena</i></span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">The Strange Tales of the Beaver Islands</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">The Ghosts of the <i>Ironsides</i></span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Legends and Ghosts of Mouth Cemetery</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">The Missing Bodies of the Cursed <i>Chicora</i></span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">A Possession in Muskegon County</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">The Murder and Ghost of Kate Koopman</span></p>
<p class="toc1"><span href="#/closing" title="Link target outside of Sample">In Closing</span></p>
<p class="toc"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/about" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?092b1fd7